<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12 3.19995C8.7967 3.19995 6.19995 5.7967 6.19995 8.99995V11.7563C6.19995 12.2471 5.84779 12.7482 5.24471 13.383C4.59799 14.0637 4.19995 14.9862 4.19995 16C4.19995 16.9941 5.00584 17.8 5.99995 17.8H18C18.9941 17.8 19.8 16.9941 19.8 16C19.8 14.9862 19.4019 14.0637 18.7552 13.383C18.1521 12.7482 17.8 12.2471 17.8 11.7563V8.99995C17.8 5.7967 15.2032 3.19995 12 3.19995Z"
			:fill="props.iconColor"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M9.84813 19.0977C10.2505 18.9151 10.7246 19.0933 10.9072 19.4957C11.0012 19.7031 11.1524 19.8794 11.3429 20.0041C11.5334 20.1288 11.7555 20.1967 11.9832 20.1999C12.2109 20.2031 12.4348 20.1414 12.6288 20.0221C12.8227 19.9027 12.9787 19.7307 13.0785 19.526C13.2722 19.1289 13.7512 18.964 14.1483 19.1577C14.5454 19.3514 14.7103 19.8303 14.5166 20.2274C14.2837 20.705 13.9197 21.1064 13.4671 21.3848C13.0146 21.6632 12.4922 21.8071 11.9609 21.7997C11.4296 21.7923 10.9114 21.6339 10.4668 21.3429C10.0222 21.052 9.66956 20.6406 9.45007 20.1567C9.26755 19.7543 9.44577 19.2802 9.84813 19.0977Z"
			:fill="props.iconColor"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12 2.19995C12.4418 2.19995 12.8 2.55812 12.8 2.99995V3.99995C12.8 4.44178 12.4418 4.79995 12 4.79995C11.5581 4.79995 11.2 4.44178 11.2 3.99995V2.99995C11.2 2.55812 11.5581 2.19995 12 2.19995Z"
			:fill="props.iconColor"
		/>
	</svg>
</template>

<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 24,
		height: 24,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
